import { render, staticRenderFns } from "./ClicImage.vue?vue&type=template&id=0fa431d6&"
import script from "./ClicImage.vue?vue&type=script&lang=js&"
export * from "./ClicImage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports